/**
 * CONFIDENTIAL AND PROPRIETARY SOURCE CODE.
 *
 * Use and distribution of this code is subject to applicable licenses and the
 * permission of the code owner. This notice does not indicate the actual or
 * intended publication of this source code.
 *
 * Portions developed for Bronner's Christmas by BTM Global Consulting LLC and are the
 * property of Bronner's Christmas.
 * =============================================================================
 * Version  Date        Author        Remarks
 * 1.0.0    2021-07-20  Tuan Le		  Bug 44519 - [Bronner] [PROD] Retail Site - Evergage product recommendations not showing
 */

define(
    'BTM.SEOPriceCurrency.SEOPriceCurrency'
    , [
        'BTM.SEOPriceCurrency.SEOPriceCurrency.View',
        'SC.Shopping.Configuration',
        'underscore'
    ]
    , function (
        SEOPriceCurrencyView,
        Configuration,
        _
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                var enabled = Configuration.get('seoPriceCurrency.enabled');
                if (!enabled) {
                    return;
                }
                var defaultCurrency = Configuration.get('seoPriceCurrency.default') || 'USD';
                Configuration.metaTagMappingOg["og:price:currency"] = _.wrap(Configuration.metaTagMappingOg["og:price:currency"], function (fn) {
                    var curr = fn.apply(this, _.toArray(arguments).slice(1));
                    if (!curr || curr === 'undefined' || curr === 'null' || curr == '') {
                        curr = defaultCurrency;
                    }
                    return curr;
                });
            }
        };
    });
